module.exports = __webpack_public_path__ + "img/expert_personal_mobile.915a0240.png";